import request from "../utils/request";

export function postRequest(functionName, params) {
    console.log('Function name:', functionName);
    console.log('Params:', params);
    return request.post('./index.php', {
        function: functionName,
        ...params
    })
}


export function loginByAdvisor(params) {
    return request.post("./index.php", {
        function: "loginByAdvisor",
        ...params,
    });
}
export function loginByAccountAdmin(admin_email, admin_password) {
    return request.post('./index.php', {
        function: 'loginByAccountAdmin',
        admin_email,
        admin_password
    })
}
export function createLoginOPT(student_email) {
    return request.post('./index.php', {
        function: 'createLoginOPT',
        student_email
    })
}

export function loginByStudent(student_email, verify_code) {
    return request.post('./index.php', {
        function: 'loginByStudent',
        student_email,
        verify_code
    })
}

// Login by password for Student
export function loginByStudentWithPassword(student_email, student_pwd) {
    return request.post('./index.php', {
        function: 'loginByStudentWithPassword',
        student_email,
        student_pwd
    })
}

// Login by password for Advisor
export function loginByAdvisorWithPassword(contact_email, contact_pwd) {
    return request.post('./index.php', {
        function: 'loginByAdvisorWithPassword',
        contact_email,
        contact_pwd
    })
}

// Send password resetting link
export function sendPasswordResettingLink(email, user_type, last_name, given_name) {
    return request.post('./index.php', {
        function: 'sendPasswordResettingLink',
        email,
        user_type,
        last_name,
        given_name
    })
}

// Update password with new password
export function updatePassword(token, user_type, user_id, new_password) {
    return request.post('./index.php', {
        function: 'updatePassword',
        token,
        user_type,
        user_id,
        new_password
    })
}

// Verify password reset token validity
export function verifyPasswordResetToken(token, user_type, user_id) {
    return request.post('./index.php', {
        function: 'verifyPasswordResetToken',
        token,
        user_type,
        user_id
    })
}

export function getSchoolAdminClubs(creator_id) {
    return request.post('./index.php', {
        function: 'getSchoolAdminClubs',
        creator_id
    })
}

export function updateClub(params) {
    return request.post('./index.php', {
        function: 'updateClub',
        ...params
    })
}

export function getContactsByAccount(account_id) {
    return request.post('./index.php', {
        function: 'getContactsByAccount',
        account_id
    })
}

export function assignedToAdvisor(club_id, advisors) {
    // Support both new format (array of objects with tenure info) and legacy format (array of IDs)
    const isNewFormat = Array.isArray(advisors) && advisors.length > 0 && typeof advisors[0] === 'object'

    if (isNewFormat) {
        return request.post('./index.php', {
            function: 'assignedToAdvisor',
            club_id,
            advisors
        })
    } else {
        // Legacy format: array of advisor IDs
        return request.post('./index.php', {
            function: 'assignedToAdvisor',
            club_id,
            advisor_ids: advisors
        })
    }
}

export function getAdvisorClubs(advisor_id) {
    return request.post('./index.php', {
        function: 'getAdvisorClubs',
        advisor_id
    })
}

export function getClubStudents(club_id) {
    return request.post('./index.php', {
        function: 'getClubStudents',
        club_id
    })
}

export function getStudentsByAccount(user_id, user_type) {
    return request.post('./index.php', {
        function: 'getStudentsByAccount',
        user_id,
        user_type
    })
}

export function addStudentToClub(params) {
    return request.post('./index.php', {
        function: 'addStudentToClub',
        ...params
    })
}

export function removeClubStudent(club_user_id) {
    return request.post('./index.php', {
        function: 'removeClubStudent',
        club_user_id
    })
}

export function getStudentClubs(student_id) {
    return request.post('./index.php', {
        function: 'getStudentClubs',
        student_id
    })
}

export function getStudentAccountClubs(student_id) {
    return request.post('./index.php', {
        function: 'getStudentAccountClubs',
        student_id
    })
}

export function getClubInfo(club_id, include_all_advisors = false) {
    return request.post('./index.php', {
        function: 'getClubInfo',
        club_id,
        include_all_advisors
    })
}

export function getAllClubAdvisors(club_id) {
    return request.post('./index.php', {
        function: 'getAllClubAdvisors',
        club_id
    })
}

export function changeStudentToClubLeader(club_user_id) {
    return request.post('./index.php', {
        function: 'changeStudentToClubLeader',
        club_user_id
    })
}

export function getAccountContactsAndClubs(account_id) {
    return request.post('./index.php', {
        function: 'getAccountContactsAndClubs',
        account_id
    })
}

export function changeAdvisorAccountStatus(advisor_id, account_status) {
    return request.post('./index.php', {
        function: 'changeAdvisorAccountStatus',
        advisor_id,
        account_status
    })
}

export function updateAdvisorInfo(params) {
    return request.post('./index.php', {
        function: 'updateAdvisorInfo',
        ...params
    })
}

export function getAdvisorSubjects() {
    return request.post('./index.php', {
        function: 'getAdvisorSubjects',
    })
}

export function removeAdvisorFromClub(club_id, advisor_id) {
    return request.post('./index.php', {
        function: 'removeAdvisorFromClub',
        club_id,
        advisor_id
    })
}

export function getClubPosts(club_id) {
    return request.post('./index.php', {
        function: 'getClubPosts',
        club_id
    })
}


export function saveAccountFormV1(form) {
    return request.post("./index.php", {
        function: "saveAccountFormV1",
        form
    });
}

export function registerAdviser(params) {
    return request.post('./index.php', {
        function: 'registerAdviser',
        ...params
    })
}

export function getStoreClub(club_id) {
    return request.post('./index.php', {
        function: 'getStoreClub',
        club_id
    })
}

export function getStoreContent(content_id) {
    return request.post('./index.php', {
        function: 'getStoreContent',
        content_id
    })
}
